// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6371) return "static/chunks/6371.beaae31dd8ed024e.js";
	if (chunkId === 3843) return "static/chunks/3843.b4435664582be13f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"520":"9d09dd46413ed215","4689":"879be621f32dde46","6492":"9f0574e22d11cb7d"}[chunkId] + ".js";
};